__turbopack_context__.v({
  "bundleItemLink": "PlanGrid-module-scss-module__eeFNOa__bundleItemLink",
  "bundleTitle": "PlanGrid-module-scss-module__eeFNOa__bundleTitle",
  "content": "PlanGrid-module-scss-module__eeFNOa__content",
  "header": "PlanGrid-module-scss-module__eeFNOa__header",
  "is-selected": "PlanGrid-module-scss-module__eeFNOa__is-selected",
  "megabundle-pick-button": "PlanGrid-module-scss-module__eeFNOa__megabundle-pick-button",
  "pick-button": "PlanGrid-module-scss-module__eeFNOa__pick-button",
  "plusNote": "PlanGrid-module-scss-module__eeFNOa__plusNote",
  "price": "PlanGrid-module-scss-module__eeFNOa__price",
  "price-text": "PlanGrid-module-scss-module__eeFNOa__price-text",
  "pricing": "PlanGrid-module-scss-module__eeFNOa__pricing",
  "pricing-overview": "PlanGrid-module-scss-module__eeFNOa__pricing-overview",
  "pricing-toggle": "PlanGrid-module-scss-module__eeFNOa__pricing-toggle",
  "pricing-toggle-wrapper": "PlanGrid-module-scss-module__eeFNOa__pricing-toggle-wrapper",
  "pricingCard": "PlanGrid-module-scss-module__eeFNOa__pricingCard",
  "pricingCardCta": "PlanGrid-module-scss-module__eeFNOa__pricingCardCta",
  "pricingCardLabel": "PlanGrid-module-scss-module__eeFNOa__pricingCardLabel",
  "pricingCardSavings": "PlanGrid-module-scss-module__eeFNOa__pricingCardSavings",
  "pricingPlans": "PlanGrid-module-scss-module__eeFNOa__pricingPlans",
  "single-price": "PlanGrid-module-scss-module__eeFNOa__single-price",
});
